import React from 'react';

import { IconBasePropsWithColor } from './IconBase';

import { colors } from 'styles/cp';

const InfoCircle: React.FC<IconBasePropsWithColor> = ({
  width = 21,
  height = 20,
  color = colors.gray,
  'aria-label': ariaLabel,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      color={color}
      aria-label={ariaLabel}
      fill="none"
    >
      <path
        d="M10.008 20H9.992C7.33984 19.9979 4.79714 18.9423 2.92328 17.0654C1.04941 15.1885 -0.00211853 12.6442 3.20461e-06 9.992C0.00212494 7.33984 1.05773 4.79714 2.93459 2.92328C4.81146 1.04942 7.35584 -0.00211853 10.008 3.20461e-06H10.023C12.6752 0.00199233 15.2179 1.05747 17.0919 2.93424C18.9658 4.81101 20.0175 7.35534 20.0155 10.0075C20.0135 12.6597 18.958 15.2024 17.0813 17.0764C15.2045 18.9503 12.6602 20.002 10.008 20ZM10.008 2C7.88627 1.99841 5.85081 2.83974 4.34939 4.33891C2.84798 5.83807 2.00359 7.87227 2.002 9.994C2.00041 12.1157 2.84174 14.1512 4.34091 15.6526C5.84007 17.154 7.87427 17.9984 9.996 18H10.008C12.1297 18.0015 14.1651 17.16 15.6665 15.6607C17.1678 14.1615 18.012 12.1272 18.0135 10.0055C18.015 7.88377 17.1735 5.84836 15.6742 4.34704C14.175 2.84572 12.1407 2.00146 10.019 2H10.008Z"
        fill={color}
      />
      <path
        d="M10.006 7.00528C10.5584 7.00528 11.0062 6.55748 11.0062 6.00508C11.0062 5.45269 10.5584 5.00488 10.006 5.00488C9.45362 5.00488 9.00582 5.45269 9.00582 6.00508C9.00582 6.55748 9.45362 7.00528 10.006 7.00528Z"
        fill="#393A3D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00562 14.0067C8.00562 13.4543 8.45342 13.0065 9.00582 13.0065H11.0062C11.5586 13.0065 12.0064 13.4543 12.0064 14.0067C12.0064 14.5591 11.5586 15.0069 11.0062 15.0069H9.00582C8.45342 15.0069 8.00562 14.5591 8.00562 14.0067Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00562 9.00568C8.00562 8.45329 8.45342 8.00548 9.00582 8.00548H10.006C10.2716 8.00548 10.5263 8.11114 10.714 8.29914C10.9016 8.48715 11.0067 8.74207 11.0062 9.00768L10.9962 14.0087C10.9951 14.5611 10.5464 15.008 9.99401 15.0069C9.44162 15.0058 8.99471 14.5571 8.99582 14.0047L9.00381 10.0059C8.45234 10.0048 8.00562 9.55741 8.00562 9.00568Z"
        fill={color}
      />
    </svg>
  );
};

export default InfoCircle;
